export default "__VITE_ASSET__a24dee76__"